import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { logger } from "@/utils/logger";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    logger.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <div className="text-center bg-white/70 backdrop-blur-md p-8 rounded-2xl shadow-soft border border-white/40">
        <h1 className="text-5xl font-bold mb-3 bg-gradient-to-r from-indigo-600 via-purple-600 to-blue-600 bg-clip-text text-transparent">404</h1>
        <p className="text-lg text-slate-700 mb-6">Oops! Page not found</p>
        <Link
          to="/"
          className="inline-block px-5 py-2.5 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-colors shadow-colored-important"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
